import { Box } from "@mui/material"
import { ApiQueries, DaymapIcon, DaymapIconType, FileItem, NoItems, useStudent, DaymapSkeleton } from "daymap-react"
import { PageContainer, PageDescriptor } from "../../../components/layout"
import { useParams } from "react-router-dom";


function Attachments() {
    const {studentId} = useParams();
    const student = useStudent(Number(studentId));
    const { isPending, data } = new ApiQueries.files.FileList({FileType: 5, LinkID:Number(studentId)}).ToQuery();

    if (isPending) {
        return <PageContainer>
            <DaymapSkeleton type="page" />
        </PageContainer>
    }

    return <PageContainer>
        <PageDescriptor icon={<DaymapIcon iconType={DaymapIconType.Schedule} />} title="Attachments">
            Download {student?.DisplaynameSurname}'s attached documents
        </PageDescriptor>
       {data?.length == 0 &&
            <NoItems >
                There are no attachments for this student
            </NoItems>
       }
        {(data?.length ?? 0) > 0 &&
            <Box sx={{ display: 'flex', flexFlow: 'column', gap: 1 }}>
                {data?.map((file) => {
                    return (
                    <FileItem key={file.FileID} name={file.FullName} 
                        description={file.Description} 
                        extension={file.Ext} 
                        modified={file.Modified} 
                        download
                        fileId={file.FileID}
                        pdf={file.Ext.toLowerCase() == "pdf"}
                    />);
                })}
            </Box>
        }
    </PageContainer>
}

export default Attachments